import { Blade } from '@nrdy-marketing-engine/dropdown-menu';
import Search from '@nrdy-marketing-engine/search/src/search';
import useSearchResults from '@nrdy-marketing-engine/search/src/use-search-results';
import dynamic from 'next/dynamic';
import { useRef, useState } from 'react';
import useOnClickOutside from 'use-onclickoutside';
import AccountNavItem from './account-nav-item';
import CartIcon from './cart-icon';

const SearchResults = dynamic(() => import('@nrdy-marketing-engine/search/src/search-results'));

export default function NavbarRight({
  i18n,
  onSearchFocus,
  searchRef,
  currentBlade,
  toggleBlade,
}: {
  i18n: any;
  onSearchFocus: () => void;
  searchRef: any;
  currentBlade: string;
  toggleBlade: (value: any, event: any) => void;
}) {
  const [searchResults, handleSearch] = useSearchResults();
  const [searchFocused, setSearchFocused] = useState(false);
  const ref = useRef<HTMLDivElement>();

  const handleSearchFocus = () => {
    onSearchFocus();
    setSearchFocused(true);
  };

  useOnClickOutside(ref, () => setSearchFocused(false));

  return (
    <div className="flex gap-4 items-center justify-end" ref={ref}>
      <div className="text-sm dark:text-md whitespace-nowrap hover:text-link dark:hover:text-white dark:hover:underline hidden xl:block dark:text-base">
        <a href={i18n.become_a_tutor.href}>{i18n.become_a_tutor.text}</a>
      </div>
      <div className="relative">
        <Search
          className="xl:-ml-2 xl:-mr-3 dark:xl:-mr-2 focus:mr-0 focus:ml-0 dark:bg-transparent dark:focus:bg-white dark:focus:text-black"
          minimized={!searchFocused}
          onClick={handleSearchFocus}
          onFocus={handleSearchFocus}
          onSearch={handleSearch}
          placeholder={i18n.right.search.placeholder}
          ref={searchRef}
        />
        {searchResults && (
          <Blade
            className="left-0 right-0"
            data-testid="blade"
            visible={searchFocused && !!searchResults}
          >
            <SearchResults
              className="bg-white shadow-lg w-full flex-col p-1 text-black"
              results={searchResults}
            />
          </Blade>
        )}
      </div>
      <CartIcon className="xl:border-l-[1px] xl:border-gray-200 xl:pl-4 dark:hidden" />
      <AccountNavItem
        className="hidden xl:block"
        currentBlade={currentBlade}
        i18n={i18n}
        toggleBlade={toggleBlade}
      />
    </div>
  );
}
